import React, {
} from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';

import {
	makeStyles,
	Typography,
	Table,
	TableBody,
	TableRow,
	TableCell
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	root: {
		flexGrow: 1,
		paddingTop: theme.spacing(1.5),
	},

	bottomSpace: {
		paddingBottom: theme.spacing(1.5)
	},

	table: {
		width: "initial",

		"& td": {
			borderBottom: "none",
			paddingLeft: 0,
			paddingTop: 0,
			paddingBottom: theme.spacing(.5),
			paddingRight: theme.spacing(1.5)
		}
	},

	tableLabel: {
		paddingRight: theme.spacing(1)
	},

	deniedMessage: {
		fontWeight: "bold"
	},

	categories: {
		paddingLeft: theme.spacing(.5)
	}
}));

function SearchDetails(props) {
	const classes = styles(),
	{searchDetails: {deniedFlag, destinationUrl, searchProvider, deniedCategories}, fidoError, ready} = props;

	const hasCategories = deniedCategories.length > 0;

	return (
		<div className={`${classes.root} ${classes.bottomSpace}`}>
			<ReactPlaceholder type='textRow' ready={ready} showLoadingAnimation={!fidoError} style={{width: "85%"}}>
				<Table className={classes.table}>
					<TableBody>
						{searchProvider ? 
							<TableRow>
								<TableCell className={classes.tableLabel}>
									<Typography>Search Provider:</Typography>
								</TableCell>
								<TableCell>
									<Typography>{searchProvider}</Typography>
								</TableCell>
							</TableRow>
							: null
						}

						{destinationUrl ? 
							<TableRow>
								<TableCell className='tableLabel'>
									<Typography>Destination Url:</Typography>
								</TableCell>
								<TableCell>
									<Typography>{destinationUrl}</Typography>
								</TableCell>
							</TableRow>
						    : null
						}
					</TableBody>
				</Table>

				{deniedFlag == 1 &&
					<div>
						<Typography className={classes.deniedMessage}>{hasCategories ? "Search was blocked for the following reasons:" : "Search was blocked."} </Typography>
						{hasCategories &&
							<div className={classes.categories}>
								{deniedCategories.map((category, index) =>
									<span className={classes.category}>{index > 0 && ", "}{category}</span>
								)}
							</div>
						}
					</div>
				}
			</ReactPlaceholder>
		</div>
	);
}

SearchDetails.propTypes = {
	searchDetails: PropTypes.object,
	fidoError: PropTypes.bool,
	ready: PropTypes.bool,
};

export default SearchDetails;
